import * as XLSX from 'xlsx';


// Kolon genişliklerini otomatik ayarlayan fonksiyon
const autoFitColumns = (data) => {
    const keys = Object.keys(data[0] || {});
    return keys.map((key) => ({
        wch: Math.max(...data.map((row) => (row[key] ? row[key].toString().length : 0)), key.length) + 2,
    }));
};

// Excel raporu oluşturma fonksiyonu
const canBusExportExcel = (vehicles, reportType, username, label) => {
    const now = new Date().toLocaleString('tr-TR');

    // Araç bilgileri ve detaylarını birleştir
    const formattedData = vehicles.map((vehicle) => {
        const {plateNumber, operationNumber, vehicleId, chassisNumber} = vehicle;

        return {
            'Plaka Numarası': plateNumber,
            'Kapı Numarası': operationNumber,
            'Cihaz ID': vehicleId,
            'Şase Numarası': chassisNumber,
        };
    });

    // Rapor başlık bilgileri
    const headerData = [
        {A: `Anlık Rapor Tarihi: ${now}`},
        {A: `Raporu Oluşturan: ${username || 'Bilinmiyor'}`},
        {A: `Uyarı İsmi: ${label}`},
        {},
    ];

    // Sayfa oluşturma ve veri ekleme
    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_json(worksheet, headerData, {skipHeader: true, origin: 'A1'});
    XLSX.utils.sheet_add_json(worksheet, formattedData, {origin: 'A5'});

    worksheet['!cols'] = autoFitColumns(formattedData);
    worksheet['!freeze'] = {xSplit: 0, ySplit: 4};

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Can Bus Dashboard Raporu');

    // Excel dosyasını kaydetme
    XLSX.writeFile(workbook, `CanBusDashboard_${label}.xlsx`);
};

export default canBusExportExcel;
